import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'coworkingAccess' as const;

export const coworkingAccessTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const allDay = getTermValue('all_day_access')(jsonQuery);
    const allWeek = getTermValue('all_week_access')(jsonQuery);
    const tags: { label: string; value: string }[] = [];

    if (allDay) {
      tags.push({ label: 'Круглосуточный доступ', value: createTagValue(ID, 'all_day_access') });
    }
    if (allWeek) {
      tags.push({ label: 'Доступ в выходные', value: createTagValue(ID, 'all_week_access') });
    }

    return tags.length > 0 ? tags : null;
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    if (removingTagValue === 'all_day_access') {
      return resetTerms(['all_day_access'])(jsonQuery);
    }
    if (removingTagValue === 'all_week_access') {
      return resetTerms(['all_week_access'])(jsonQuery);
    }

    return jsonQuery;
  },
};
